import { render, staticRenderFns } from "./CloseButtonAtom.vue?vue&type=template&id=0f6541fc&"
import script from "./CloseButtonAtom.vue?vue&type=script&lang=ts&"
export * from "./CloseButtonAtom.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports